import React from 'react';
import {
    EyeIcon,
    FunnelIcon,
    Squares2X2Icon,
    TableCellsIcon
} from '@heroicons/react/24/outline';
import { ViewMode } from './ProposalList'; // Changed from ProjectList

interface ProposalFiltersProps { // Renamed from ProjectFiltersProps
    showLeadsOnly: boolean;
    setShowLeadsOnly: (show: boolean) => void;
    setIsFilterModalOpen: (isOpen: boolean) => void;
    viewMode: ViewMode;
    setViewMode: (mode: ViewMode) => void;
    isMobile: boolean;
}

export default function ProposalFilters({ // Renamed from ProjectFilters
    showLeadsOnly,
    setShowLeadsOnly,
    setIsFilterModalOpen,
    viewMode,
    setViewMode,
    isMobile
}: ProposalFiltersProps) {
    return (
        <div className="flex justify-between items-center mb-6">
            {/* Text updated from Projetos to Propostas */}
            <h3 className="text-lg font-medium leading-6 text-gray-900">Propostas Cadastradas</h3>
            <div className="flex items-center space-x-2">
                <button
                    onClick={() => setShowLeadsOnly(!showLeadsOnly)}
                    className={`p-2 rounded-md ${showLeadsOnly
                        ? 'bg-blue-100 text-blue-600'
                        : 'text-gray-500 hover:bg-gray-100'
                        }`}
                    // Title updated from "projetos em negociação" to "propostas em negociação"
                    title="Mostrar apenas propostas em negociação"
                >
                    <EyeIcon className="h-5 w-5" />
                </button>
                <button
                    onClick={() => setIsFilterModalOpen(true)}
                    className="p-2 rounded-md text-gray-500 hover:bg-gray-100"
                    // Title updated from "Filtrar projetos" to "Filtrar propostas"
                    title="Filtrar propostas"
                >
                    <FunnelIcon className="h-5 w-5" />
                </button>
                {!isMobile && (
                    <div className="flex items-center border-l border-gray-200 pl-2">
                        <button
                            onClick={() => setViewMode('cards')}
                            className={`p-2 rounded-md ${viewMode === 'cards'
                                ? 'bg-gray-100 text-gray-900'
                                : 'text-gray-500 hover:bg-gray-100'
                                }`}
                            title="Visualização em cards"
                        >
                            <Squares2X2Icon className="h-5 w-5" />
                        </button>
                        <button
                            onClick={() => setViewMode('table')}
                            className={`p-2 rounded-md ${viewMode === 'table'
                                ? 'bg-gray-100 text-gray-900'
                                : 'text-gray-500 hover:bg-gray-100'
                                }`}
                            title="Visualização em tabela"
                        >
                            <TableCellsIcon className="h-5 w-5" />
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
} 